import React, { useMemo } from "react";
import { TopSourcesBody } from "./components";
import { formatCount } from "./components/utils";
const parseNumberValue = (value) => {
    if (typeof value === "number" && Number.isFinite(value))
        return value;
    if (typeof value === "string") {
        const parsed = Number.parseFloat(value);
        if (Number.isFinite(parsed))
            return parsed;
    }
    return null;
};
// Below this a source carries too little weight to act on. Exported because the quadrant and the
// print template filter on the same rule, and three copies of the number would drift apart.
export const MIN_CITATION_WEIGHT = 3;
const filterSourcesByCitationWeight = (sources) => sources.filter((source) => {
    const weight = parseNumberValue(source.citationWeight);
    return weight !== null && weight >= MIN_CITATION_WEIGHT;
});
// Percentages and gaps stay unrounded here: the row's formatters round once for display, and
// pre-rounding to one decimal would round twice (3.456 -> 3.5 -> 4%).
const mapSources = (sources, rankOffset = 0) => sources.map((source, index) => {
    var _a, _b, _c, _d, _e;
    return ({
        rank: rankOffset + index + 1,
        name: source.source,
        citationWeight: (_a = parseNumberValue(source.citationWeight)) !== null && _a !== void 0 ? _a : "-",
        citationWeightChange: (_b = source.citationWeightChange) !== null && _b !== void 0 ? _b : null,
        topPerformerCitations: formatCount(source.topPerformerCitations),
        yourCitations: formatCount(source.yourCitations),
        gap: (_c = parseNumberValue(source.gap)) !== null && _c !== void 0 ? _c : "-",
        gapChange: (_d = source.gapChange) !== null && _d !== void 0 ? _d : null,
        yourCitationsChange: (_e = source.yourCitationsChange) !== null && _e !== void 0 ? _e : null,
        status: source.status,
    });
});
export const TopSources = ({ topSources, rankOffset = 0, highlightedSourceName, scrollToSourceName, onRowHover, }) => {
    const sources = useMemo(() => {
        if (!(topSources === null || topSources === void 0 ? void 0 : topSources.length))
            return [];
        const filtered = filterSourcesByCitationWeight(topSources);
        return mapSources(filtered, rankOffset);
    }, [topSources, rankOffset]);
    if (!sources.length) {
        return null;
    }
    return (React.createElement(TopSourcesBody, { sources: sources, highlightedSourceName: highlightedSourceName, scrollToSourceName: scrollToSourceName, onRowHover: onRowHover }));
};
export default TopSources;
